import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

// Frontend build identifier for deployment validation
// Increment this when deploying to verify new code is served
(window as any).LIT_BUILD = '2026.01.09.007';

// Configure Monaco Editor worker URLs
// Monaco workers use AMD modules, so we create blob URLs that bootstrap them properly
(window as any).MonacoEnvironment = {
  getWorker: function (_workerId: string, label: string) {
    const base = (window as any).location.origin;
    let workerUrl = `${base}/assets/monaco/min/vs/editor/editor.worker.js`;

    if (label === 'json') {
      workerUrl = `${base}/assets/monaco/min/vs/language/json/jsonWorker.js`;
    } else if (label === 'css' || label === 'scss' || label === 'less') {
      workerUrl = `${base}/assets/monaco/min/vs/language/css/cssWorker.js`;
    } else if (label === 'html' || label === 'handlebars' || label === 'razor') {
      workerUrl = `${base}/assets/monaco/min/vs/language/html/htmlWorker.js`;
    } else if (label === 'typescript' || label === 'javascript') {
      workerUrl = `${base}/assets/monaco/min/vs/language/typescript/tsWorker.js`;
    }

    // Create a blob URL that imports the worker script properly
    const blob = new Blob(
      [`importScripts('${base}/assets/monaco/min/vs/base/worker/workerMain.js');`],
      { type: 'application/javascript' }
    );
    return new Worker(URL.createObjectURL(blob), { type: 'classic' });
  }
};

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));
